import { Home } from "lucide-react";
import type { SidebarItem } from "@/types/navigation";
import { SECTION_DEFINITIONS, type SectionId } from "@/config/uiConfig";

type HomeNavItem = SidebarItem & { id: "overview" | SectionId };

/** Sidebar entries for the Home dashboard. Acts as a "All services" jump list. */
export const HOME_NAV: HomeNavItem[] = [
  { id: "overview", label: "Overview", href: "/home", icon: Home },
  ...SECTION_DEFINITIONS.map(({ id, label, href, icon }) => ({ id, label, href, icon })),
];

export function getAuthorizedHomeNavItems(canAccessSection: (sectionId: SectionId) => boolean) {
  return HOME_NAV.filter((item) => item.id === "overview" || canAccessSection(item.id));
}
